module.exports = __webpack_public_path__ + "img/button_box_up.45d0f9e1.png";